import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import {
  faCheck,
  faTrophy,
  faInfoCircle,
  faSeedling,
} from "@fortawesome/free-solid-svg-icons";
import companyPlacementHistoryType from "./types/companyPlacementHistoryType";
import companyEngagementHistoryType from "./types/companyEngagementHistoryType";
import {
  Wrapper,
  Title,
  TitleText,
  Tooltip,
  Engagements,
  Placements,
  MobileTitle,
  Body,
  ListItem,
  ListItemText,
  ViewMore,
  MobileViewMore,
  ViewMoreButton,
  EngagementsPlaceholder,
  PlacementsPlaceholder,
  PlaceholderText,
} from "./styles/engagements-placements-styles";

export const EngagementsPlacements = ({
  companyEngagementHistory,
  companyPlacementHistory,
  toggleEngagementsPlacementsModal,
  engagementsLength,
  placementsLength,
  user,
}) => (
  <Wrapper className="animated delay-5 fadeIn">
    <Title>
      <TitleText>Company Engagement and Placement History</TitleText>
      <Tooltip
        data-tip="Recent engagements on the <strong>left</strong>,<br>recent placements on the <strong>right</strong>"
        data-for="eng-plac-tooltip"
      >
        <FontAwesomeIcon icon={faInfoCircle} />
      </Tooltip>
      <ReactTooltip
        html
        place="bottom"
        type="dark"
        effect="solid"
        aria-haspopup="true"
        id="eng-plac-tooltip"
      />
    </Title>
    <Body>
      {engagementsLength < 1 && user.isRecruiter && (
        <EngagementsPlaceholder>
          <FontAwesomeIcon icon={faSeedling} />
          <PlaceholderText>
            To grow your profile, get engaging on roles! Your accepted
            engagements will display here.
          </PlaceholderText>
        </EngagementsPlaceholder>
      )}
      {engagementsLength < 1 && !user.isRecruiter && (
        <EngagementsPlaceholder>
          <FontAwesomeIcon icon={faSeedling} />
          <PlaceholderText>
            We’re working on getting our first Hiring Hub engagements and
            placement right now!
          </PlaceholderText>
        </EngagementsPlaceholder>
      )}
      <Engagements>
        <MobileTitle>engagements:</MobileTitle>
        {companyEngagementHistory.map((engagement) =>
          engagement.job ? (
            <ListItem key={engagement.id} data-test-id="engagement-list-item">
              <FontAwesomeIcon icon={faCheck} />
              <ListItemText>{engagement.job.title}</ListItemText>
            </ListItem>
          ) : null
        )}
      </Engagements>
      <Placements>
        {placementsLength < 1 && (
          <PlacementsPlaceholder placements={engagementsLength}>
            <PlaceholderText placements>
              We’re working on getting our first Hiring Hub placement!
            </PlaceholderText>
          </PlacementsPlaceholder>
        )}
        {placementsLength > 0 && <MobileTitle>placements:</MobileTitle>}
        {companyPlacementHistory.map((placement) =>
          placement.job ? (
            <ListItem key={placement.id} data-test-id="placement-list-item">
              <FontAwesomeIcon icon={faTrophy} />
              <ListItemText>{placement.job.title}</ListItemText>
            </ListItem>
          ) : null
        )}
      </Placements>
      {(engagementsLength > 3 || placementsLength > 3) && (
        <ViewMore>
          <ViewMoreButton onClick={() => toggleEngagementsPlacementsModal()}>
            see more
          </ViewMoreButton>
        </ViewMore>
      )}
      {engagementsLength + placementsLength > 2 && (
        <MobileViewMore>
          <ViewMoreButton onClick={() => toggleEngagementsPlacementsModal()}>
            see more
          </ViewMoreButton>
        </MobileViewMore>
      )}
    </Body>
  </Wrapper>
);

EngagementsPlacements.propTypes = {
  companyEngagementHistory: companyEngagementHistoryType.isRequired,
  companyPlacementHistory: companyPlacementHistoryType.isRequired,
  toggleEngagementsPlacementsModal: PropTypes.func.isRequired,
  engagementsLength: PropTypes.number.isRequired,
  placementsLength: PropTypes.number.isRequired,
  user: PropTypes.shape({
    isRecruiter: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  companyEngagementHistory:
    state.agencyProfile.profileData.companyEngagementHistory,
  companyPlacementHistory:
    state.agencyProfile.profileData.companyPlacementHistory,
  engagementsLength:
    state.agencyProfile.profileData.companyEngagementHistory.length,
  placementsLength:
    state.agencyProfile.profileData.companyPlacementHistory.length,
  user: state.agencyProfile.profileData.user,
});

export default connect(mapStateToProps, {})(EngagementsPlacements);
